
import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Tab } from 'react-bootstrap'
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { Link, useLocation } from 'react-router-dom';
import { json } from "stream/consumers";
import clsx from 'clsx';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from "../../../common/Toastr";
import fetchAPI from "../../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import './ExpenseApproval.css'
import moment from "moment";
import 'rsuite/dist/rsuite.css';
import { useTranslation } from "react-i18next";
import { ExpenseApprovalClass } from "./interfaces/ExpenseApprovalClass";
import AttachmentModal from "../../attachment/AttachmentModal";
import '../../../common/css/timeLive.css'
import { useReactToPrint } from "react-to-print";
import CanvasLoader from "../../../common/CanvasLoader";
import { formatCurrntDateTime, formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from "../../../common/timeLiveFunction";


const ExpenseApprovalPrintForm = (props: any) => {
    const { data, onSetShowPrint } = props;
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [masterReimburse, setMasterReimburse] = useState('');
    const [masterDescription, setDescription] = useState('');
    const [expenseSheet, SetExpenseSheet] = useState<any | ''>([]);
    const [expenseEntryRecord, SetExpenseEntryRecord] = useState<any | ''>([]);
    const [customFields, SetCustomFields] = useState<any | ''>([]);
    const [reimburseAmount, SetReimburseAmount] = useState<any | ''>([]);
    const [reimburseData, SetReimburseData] = useState<any | ''>({});
    const [exchangeRate, SetExchangeRate] = useState<any>(0);
    const [sheetCustomFields, SetSheetCustomFields] = useState<any | ''>([]);
    const [isShowElectronicSign, setIsShowElectronicSign] = useState(true);
    const [isElectronicSignExistInSessionAccount, setIsElectronicSignExistInSessionAccount] = useState(true);
    const [signedBy, setSignedBy] = useState('');
    const [imageURL, setImageURL] = useState('');
    const { cultureInfoName, accountPreferenceList, isCompanyOwnLogo } = useAppSelector((state) => state.globalState);
    const [expenseSheetPrintFooter, SetExpenseSheetPrintFooter] = useState('');
    const [id, setId] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const attachmentModelRef = useRef<any>(null);
    const componentRef = useRef<HTMLDivElement>(null);
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);
    const [logoURL, setLogoURL] = useState<string>("");
    const { decimalPlaces } = useAppSelector((state) => state.globalState);
    const [summittedBaseTotal, setSubmittedBaseTotal]=useState<number>(0.00);

    const GetAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdNew = async (data: any) => {
        const response = await fetchAPI('api/V2/Expenses/ExpenseSheetNew/' + data.expenseApprovalObject.AccountEmployeeExpenseSheetId + '/0/' + data.filterProjects + '/' + data.expenseApprovalObject.SystemApproverTypeId + '/' + 2 + '/' + isCompanyOwnLogo, 'GET', '', true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        SetExpenseSheet(json.Data[0][0]);
        SetExpenseEntryRecord(json.Data[1])
        SetCustomFields(json.Data[5]);
        SetReimburseAmount(json.Data[2]);
        SetReimburseData(json.Data[3][0]);
        SetExchangeRate(json.Data[7]);
        SetSheetCustomFields(json.Data[6]);
        setImageURL(json.Data[8]);
        setIsElectronicSignExistInSessionAccount(json.Data[9]);
        setLogoURL(json.Data[10])
        let CFRow: any = 0;
        var SheetCustomFields = sheetCustomFields;
        if (Object.keys(SheetCustomFields).length > 0) {
            if (Object.keys(SheetCustomFields[0]).length > 0) {
                //$("#SheetCF").show();
            }
        }
        if (SheetCustomFields.length > 0) {
            // add into grid
            var SheetCustomFieldHeading = "";
            for (const key in SheetCustomFields[0]) {
                SheetCustomFieldHeading += "<th nowrap id='" + key + "'>" + key + "</th>";
            }
            //$("#ExpenseSheetHead").html(SheetCustomFieldHeading);
        }
        if (SheetCustomFields.length > 0) {
            var CFSheetVal = "<tr>";
            $.each(SheetCustomFields[0], function (val) {
                CFSheetVal += "<td  nowrap align='left' style='vertical-align:middle;'>" + SheetCustomFields[0][val] + "</td>";
            });
            CFSheetVal += "</tr>";
            //$("#ExpenseSheetBody").html(CFSheetVal);
        }
        setIsCanvasLoader(false);
    }

    useEffect(() => {
        if (accountPreferenceList.length > 0) {
            SetExpenseSheetPrintFooter(accountPreferenceList[0].ExpenseSheetPrintFooter)
            setIsShowElectronicSign(accountPreferenceList[0].IsShowElectronicSign);
        }
        GetAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdNew(data)
    }, [])

    useEffect(() => {
        let TotalAmount: any = 0.00;
        let TotalReimburseAmount: any = 0.00;
        if (expenseSheet) {
            setDescription(expenseSheet.Description);
            setSignedBy(expenseSheet.EmployeeName);
        }
        if (reimburseAmount) {
            reimburseAmount.forEach((obj: any) => {
                if (obj.Reimburse && !obj.Approved) {
                    // TotalAmount += parseFloat(obj.Amount) * parseFloat(obj.ExchangeRate);
                     TotalAmount += parseFloat(obj.Amount) / parseFloat(obj.ExchangeRate);
                }
            });
        }
        if (exchangeRate) {
            if (exchangeRate != 0) {
                TotalReimburseAmount = parseFloat(TotalAmount) * parseFloat(exchangeRate);
            }
            else {
                TotalReimburseAmount = 1 * parseFloat(TotalAmount);
            }

            setMasterReimburse(FormatInvoiceDecimalNumber(cultureInfoName.toString(), TotalReimburseAmount, decimalPlaces));
        }
    }, [expenseSheet, reimburseAmount, exchangeRate])

    useEffect(()=>{
        calculateSummittedTotalInBaseCurrency();
    },[reimburseAmount])
    const calculateSummittedTotalInBaseCurrency = () => {
         let TotalAmount: any = 0.00;
        if (reimburseAmount) {
            reimburseAmount.forEach((obj: any) => {
                if (obj.Reimburse && !obj.Approved) {
                    TotalAmount += parseFloat(obj.Amount) / parseFloat(obj.ExchangeRate);
                }
                setSubmittedBaseTotal(TotalAmount)
            });
        }
    }

    const statusExpenseSheet = (selectedStatus: any) => {

        let status: any = "";
        if (selectedStatus == "Not Submitted") {
            status = (
                <span className="badge badge-light-warning fs-5">
                    {/* {t('Not Submitted')}  */}
                    {getValueFromResource('Not Submitted', dispatch, t)}
                </span>
            )
        } else if (selectedStatus == "Submitted") {
            status = (
                <span className="badge badge-light-primary fs-5">
                    {/* {t('Submitted')}  */}
                    {getValueFromResource('Submitted', dispatch, t)}
                </span>
            )
        } else if (selectedStatus == "Approved") {
            status = (
                <span className="badge badge-light-success fs-5">
                    {/* {t('Approved')} */}
                    {getValueFromResource('Approve', dispatch, t)}

                </span>
            )
        } else if (selectedStatus == "Rejected") {
            status = (
                <span className="badge badge-light-danger fs-5">
                    {/* {t('Rejected')}    */}
                    {getValueFromResource('Reject', dispatch, t)}
                </span>
            )
        }
        return status;
    }

    const calculateTotalNetAmount = () => {
        let totalNetAmount = 0;
        expenseEntryRecord.forEach((SheetDetails: any) => {
            totalNetAmount += parseFloat(SheetDetails.NetAmount);
        });
        return numberWithCommas(totalNetAmount.toFixed(2));
    };

    const calculateTotalTaxAmount = () => {
        let taxAmount = 0;
        expenseEntryRecord.forEach((SheetDetails: any) => {
            taxAmount += parseFloat(SheetDetails.TaxAmount);
        });
        return numberWithCommas(taxAmount.toFixed(2));
    };

    const calculateTotalAmount = () => {
        let totalAmount: any = 0.00;
        let FinalAmount: any = 0.00;
        expenseEntryRecord.forEach((SheetDetails: any) => {
            totalAmount += parseFloat(SheetDetails.Amount);
        });
        if (Object.keys(data.expenseApprovalObject).length > 0) {
            const MasterSheet: any = data.expenseApprovalObject;
            FinalAmount = MasterSheet.BaseCurrencyCode + ' ' + totalAmount.toFixed(2)
        }
        return numberWithCommas(FinalAmount);
    };

    const numberWithCommas = (x: any) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    const handleAttachment = (AccountExpenseEntryId: any) => {
        setId(AccountExpenseEntryId);
        setModalIsOpen(true);
    }
    useEffect(() => {
        if (modalIsOpen) {
            if (attachmentModelRef.current) {
                attachmentModelRef.current.click();
            }
        }
    }, [modalIsOpen])
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    return (
        <>
            <div className="modal drawer-overlay" tabIndex={-1} data-bs-backdrop="false" style={{ display: 'block' }}>
                <div className='modal-dialog modal-xl'>
                    <div className='modal-content rounded'>
                        <div className='modal-header pb-2'>
                            <h6>
                                {/* {t('Expense Entry')} */}
                                {/* {getValueFromResource('Expense Entry', dispatch, t)} */}
                                {getValueFromResource('Expense Sheet', dispatch, t)}
                            </h6>
                            <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={() => onSetShowPrint(false)}>
                                <KTIcon iconName='cross' className='fs-1 svg-icon-1x' />
                            </div>
                        </div>
                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                            {isCanvasLoader ? <CanvasLoader /> : <>
                                <div className='row text-center mb-13' style={{ marginTop: 14 }}>
                                    <div className='col-md-3 col-sm-3 col-xs-12'>
                                        <span className='tsDetailModalLabel' style={{ paddingLeft: 0 }}>
                                            {/* {t('Employee Name')} */}
                                            {getValueFromResource('Employee Name', dispatch, t)}
                                        </span><br />
                                        <span className='tsDetailModalText'>{expenseSheet.EmployeeName}</span>
                                    </div>
                                    <div className='col-md-3 col-sm-3 col-xs-12'>
                                        <span className='tsDetailModalLabel'>
                                            {/* {t('Entry Date')} */}
                                            {/* {getValueFromResource('Entry Date', dispatch, t)} */}
                                            {getValueFromResource('Sheet Date', dispatch, t)}
                                        </span><br />
                                        {/* <span className='tsDetailModalText'>{`${moment.parseZone(expenseSheet.ExpenseSheetDate).format('DD MMM yy')}`}</span> */}
                                        <span className='tsDetailModalText'>{`${formatDateWithDateAndMonthName(expenseSheet.ExpenseSheetDate, cultureInfoName.toString())}`}</span>
                                    </div>
                                    <div className='col-md-3 col-sm-3 col-xs-12'>
                                        <span className='tsDetailModalLabel'>
                                            {/* {t('Total Reimbursement')} */}
                                            {getValueFromResource('Total Reimbursement', dispatch, t)}
                                        </span><br />
                                        <span className='tsDetailModalText'>{reimburseAmount.length > 0 ? reimburseAmount[0].ReimbursementCurrencyCode : ""} {masterReimburse ? masterReimburse : "0"}</span>
                                    </div>
                                    <div className='col-md-3 col-sm-3 col-xs-12'>
                                        <span className='tsDetailModalLabel'>
                                            {/* {t('Status')} */}
                                            {getValueFromResource('Status', dispatch, t)}
                                        </span><br />
                                        <span className='tsDetailModalText'>{statusExpenseSheet(expenseSheet.Status)}</span>
                                    </div>
                                </div>
                                <table className='tsReportCommentTable table-bordered'>
                                    <thead>
                                        <tr className='tsReportCommentThead' style={{ textAlign: 'center' }}>
                                            <th>

                                                {/* {t('Date')} */}
                                                {getValueFromResource('Date', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Project Name')} / {t('Expense Name')} */}
                                                {getValueFromResource('Project Name / Expense Name', dispatch, t)}
                                            </th>
                                            <th>
                                                {getValueFromResource('Desciption', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Payment Method')} */}
                                                {getValueFromResource('Payment Method', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Tax Code')} */}
                                                {getValueFromResource('Tax Code', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Billable')} */}
                                                {getValueFromResource('Billable', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Quantity')} */}
                                                {getValueFromResource('Quantity', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Rate')} */}
                                                {getValueFromResource('Rate', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Net')} */}
                                                {getValueFromResource('Net', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Tax')} */}
                                                {getValueFromResource('Tax', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Amount')} */}
                                                {getValueFromResource('Amount', dispatch, t)}
                                            </th>
                                            <th>

                                                {/* {t('Attachment')} */}
                                                {getValueFromResource('Attachment', dispatch, t)}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {expenseEntryRecord.length === 0 && <tr><td>
                                            {/* {t('No Record Found.')} */}
                                            {getValueFromResource('No Record Found.', dispatch, t)}
                                        </td></tr>}
                                        {expenseEntryRecord.length > 0 && expenseEntryRecord.map((objExpenseEntryRecord: any, i: any) => {
                                            return(
                                            <tr key={i} className='tsReportCommentTbody' style={{ textAlign: 'center' }}>
                                                <td style={{ paddingLeft: 10 }}>{formatDateWithDateAndMonthName(objExpenseEntryRecord.AccountExpenseEntryDate, cultureInfoName.toString())}</td>
                                                <td >{objExpenseEntryRecord.ProjectCode ? "(" + objExpenseEntryRecord.ProjectCode + ") " : ""}  {objExpenseEntryRecord.ProjectName + " • " + objExpenseEntryRecord.AccountExpenseName}</td>
                                                <td >{objExpenseEntryRecord.Description ? objExpenseEntryRecord.Description : ""}</td>
                                                <td >{objExpenseEntryRecord.PaymentMethod ? objExpenseEntryRecord.PaymentMethod : ""}</td>
                                                <td >{objExpenseEntryRecord.TaxCode ? objExpenseEntryRecord.TaxCode : ""}</td>
                                                <td >{objExpenseEntryRecord.isBillable == 1 ? "Yes" : "No"}</td>
                                                <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.Quantity, decimalPlaces)}</td>
                                                <td >{objExpenseEntryRecord.Rate !== null ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.Rate, decimalPlaces) : '0.00'}</td>
                                                <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.NetAmount, decimalPlaces)}</td>
                                                <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.TaxAmount, decimalPlaces)}</td>
                                                <td >{objExpenseEntryRecord.CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.Amount, decimalPlaces)}</td>
                                                <td> <a
                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                    data-tooltip-id="tooltip-Description"
                                                    data-tooltip-content=
                                                    // {t("Attachment")}
                                                    {getValueFromResource('Attachment', dispatch, t)}
                                                    data-tooltip-place="bottom"
                                                    onClick={() => handleAttachment(objExpenseEntryRecord.AccountExpenseEntryId)}
                                                >
                                                    <i className="bi bi-paperclip fs-3 iconColor"></i>
                                                </a>
                                                </td>
                                            </tr>
                                        )})}
                                    </tbody>
                                    <tfoot>
                                        {expenseEntryRecord.length > 0 && (
                                            <tr>
                                                <td className='tsReportInfoTbody text-center'> <span className="task projectTaskHeading">
                                                    {/* {t('Total')} */}
                                                    {getValueFromResource('Total', dispatch, t)}
                                                </span></td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                <td className='tsReportInfoTbody'> </td>
                                                  <td className='tsReportInfoTbody text-center' ></td>
                                                <td className='tsReportInfoTbody text-center'></td>
                                                {/* <td className='tsReportInfoTbody text-center' > {calculateTotalNetAmount()} </td> */}
                                                {/* <td className='tsReportInfoTbody text-center'> {calculateTotalTaxAmount()} </td> */}
                                                <td className='tsReportInfoTbody text-center'> {expenseSheet?.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), summittedBaseTotal, decimalPlaces)} </td>
                                                {/* <td className='tsReportInfoTbody text-center'> {calculateTotalAmount()} </td>                                      */}
                                                <td className='tsReportInfoTbody'> </td>
                                            </tr>
                                        )}
                                    </tfoot>
                                </table></>
                            }
                        </div>
                        <div className="modal-footer">
                            <a
                                onClick={() => { handlePrint() }}
                                className={"btn btn-primary btn-sm "}>
                                <i className="bi bi-printer fs-5 me-1"></i>
                                {/* {t('Print Expense Sheet')} */}
                                {getValueFromResource('Print Expense Sheet', dispatch, t)}
                            </a>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'none' }}>
                    <div ref={componentRef}>
                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5'>
                            <div className='row text-left mb-13' style={{ marginTop: 25 }}>

                                {isCompanyOwnLogo ?
                                    <img src={logoURL} className='tsReportIcon' style={{ width: '200px', height: '50px', paddingLeft: 20, marginBottom: 8 }} />
                                    :
                                    <>
                                        <img src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')} className='tsReportLogo' />
                                    </>
                                }
                                <span className='textDarkBlue' style={{ fontWeight: 600, fontSize: 20 }}>
                                    {/* {t('Expense Summary')} */}
                                    {getValueFromResource('Expense Summary', dispatch, t)}
                                </span>
                                <span className='lightGray' style={{ fontWeight: 500, fontSize: 14, marginLeft: 1 }}>
                                    {/* {`${moment.parseZone(expenseSheet.ExpenseSheetDate).format('DD MMM yy')}`} */}
                                    {`${formatDateWithDateAndMonthName(expenseSheet.ExpenseSheetDate, cultureInfoName.toString())}`}
                                    </span>
                                <div style={{ marginLeft: -5, marginTop: 20 }}>
                                    <span className='reportLabel'>
                                        {/* {t('Total Reimbursement:')} */}
                                        {getValueFromResource('Total Reimbursement:', dispatch, t)}
                                    </span>
                                    <span className='reportText'>{reimburseAmount.length > 0 ? reimburseAmount[0].ReimbursementCurrencyCode : ""} {masterReimburse ? masterReimburse : "0"}</span>
                                    <span className='reportLabel'>
                                        {/* {t('Status:')} */}
                                        {getValueFromResource('Status:', dispatch, t)}
                                    </span>
                                    <span className='reportText'>{expenseSheet.Status}</span>
                                    <span className='reportLabel' style={{ paddingLeft: 6 }}>
                                        {/* {t('Employee Name:')} */}
                                        {getValueFromResource('Employee Name:', dispatch, t)}
                                    </span>
                                    <span className='reportText'>{expenseSheet.EmployeeName}</span>
                                </div>
                            </div>
                            <table className='tsReportCommentTable'>
                                <thead>
                                    <tr className='tsReportCommentThead text-center'>
                                        <th>
                                            {/* {t('Date')} */}
                                            {getValueFromResource('Date', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Project Name')} / {t('Expense Name')} */}
                                            {getValueFromResource('Project Name / Expense Name', dispatch, t)}
                                        </th>
                                        <th>
                                            {getValueFromResource('Description', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Payment Method')} */}
                                            {getValueFromResource('Payment Method', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Tax Code')} */}
                                            {getValueFromResource('Tax Code', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Billable')} */}
                                            {getValueFromResource('Billable', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Quantity')} */}
                                            {getValueFromResource('Quantity', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Rate')} */}
                                            {getValueFromResource('Rate', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Net')} */}
                                            {getValueFromResource('Net', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Tax')} */}
                                            {getValueFromResource('Tax', dispatch, t)}
                                        </th>
                                        <th>
                                            {/* {t('Amount')} */}
                                            {getValueFromResource('Amount', dispatch, t)}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {expenseEntryRecord.length === 0 && <tr><td>
                                        {/* {t('No Record Found.')} */}
                                        {getValueFromResource('No Record Found.', dispatch, t)}
                                    </td></tr>}
                                    {expenseEntryRecord.length > 0 && expenseEntryRecord.map((objExpenseEntryRecord: any, i: any) => (
                                        <tr key={i} className='tsReportCommentTbody' style={{ textAlign: 'center' }}>
                                            <td style={{ paddingLeft: 10 }}>{formatDateWithDateAndMonthName(objExpenseEntryRecord.AccountExpenseEntryDate, cultureInfoName.toString())}</td>
                                            <td >{objExpenseEntryRecord.ProjectCode ? "(" + objExpenseEntryRecord.ProjectCode + ") " : ""}  {objExpenseEntryRecord.ProjectName + " • " + objExpenseEntryRecord.AccountExpenseName}</td>
                                            <td >{objExpenseEntryRecord.Description ? objExpenseEntryRecord.Description : ""}</td>
                                            <td >{objExpenseEntryRecord.PaymentMethod ? objExpenseEntryRecord.PaymentMethod : ""}</td>
                                            <td >{objExpenseEntryRecord.TaxCode ? objExpenseEntryRecord.TaxCode : ""}</td>
                                            <td >{objExpenseEntryRecord.isBillable == 1 ? "Yes" : "No"}</td>
                                            <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.Quantity, decimalPlaces)}</td>
                                            <td >{objExpenseEntryRecord.Rate !== null ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.Rate, decimalPlaces) : 'a0.00'}</td>
                                            <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.NetAmount, decimalPlaces)}</td>
                                            <td >{FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.TaxAmount, decimalPlaces)}</td>
                                            <td >{objExpenseEntryRecord.CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), objExpenseEntryRecord.Amount, decimalPlaces)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    {expenseEntryRecord.length > 0 && (
                                        <tr>
                                            <td className='tsReportInfoTbody text-center'> <span className="task projectTaskHeading">
                                                {/* {t('Total')} */}
                                                {getValueFromResource('Total', dispatch, t)}
                                            </span></td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                            <td className='tsReportInfoTbody'> </td>
                                              <td className='tsReportInfoTbody text-center' ></td>
                                                <td className='tsReportInfoTbody text-center'></td>
                                            {/* <td className='tsReportInfoTbody text-center' > {calculateTotalNetAmount()} </td>
                                            <td className='tsReportInfoTbody text-center'> {calculateTotalTaxAmount()} </td> */}
                                            <td className='tsReportInfoTbody text-center'> {expenseSheet?.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), summittedBaseTotal, decimalPlaces)} </td>
                                            {/* <td className='tsReportInfoTbody text-center'> {calculateTotalAmount()} </td> */}

                                        </tr>
                                    )}
                                </tfoot>
                            </table>
                            <div className='row' >
                                <textarea defaultValue={expenseSheetPrintFooter} rows={10} style={{ borderRadius: 0, borderStyle: 'none' }}>
                                </textarea>
                            </div>
                            {isShowElectronicSign &&
                                <div id="electronicSignature">
                                    <div className='text-left mb-2'>
                                        <span className='commentHeading'>
                                            {/* {t('Electronic Signature:')} */}
                                            {getValueFromResource('Electronic Signature:', dispatch, t)}
                                        </span>
                                    </div>
                                    <div className='text-left mb-1'>
                                        <span className='reportLabel' style={{ paddingLeft: 6 }}>
                                            {/* {t('Signed By:')}  */}
                                            {getValueFromResource('Signed By', dispatch, t)}
                                        </span>
                                        <span className='reportText'>{signedBy}</span>
                                    </div>
                                    {isElectronicSignExistInSessionAccount &&
                                        <div className='text-left mb-1'>
                                            <span className='reportLabel' style={{ paddingLeft: 6, paddingRight: 6 }}>
                                                {/* {t('Signature:')} */}
                                                {getValueFromResource('Signature', dispatch, t)}
                                            </span>
                                            <img id="imgElectronicSignature" alt="" src={imageURL} style={{ height: '50px' }} />
                                        </div>
                                    }
                                    <div className='text-left mb-1'>
                                        <span className='reportLabel' style={{ paddingLeft: 6 }}>
                                            {/* {t('Timestamp:')} */}
                                            {getValueFromResource('Timestamp:', dispatch, t)}
                                        </span>
                                        {/* <span className="reportText">{moment().format('DD-MM-YYYY HH:mm:ss')}</span> */}
                                        <span className="reportText"> {formatCurrntDateTime(new Date(), cultureInfoName.toString())}</span>
                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
            {modalIsOpen && (
                <>
                    <AttachmentModal
                        isOpen={modalIsOpen}
                        closeModal={() => setModalIsOpen(false)}
                        Id={id}
                        IsUploadRequired={false}
                        AccountAttachmentTypeId={1}
                    />

                </>
            )
            }
        </>
    )

}

export default ExpenseApprovalPrintForm;
